/* ============================================================================
   ROAM — Cart drawer behaviour.
   Vanilla JS, no dependencies. Handles open/close, the qty steppers and the
   REMOVE links. Every quantity change goes through /cart/change.js and then
   re-renders the drawer server-side via the Section Rendering API, so line
   prices, the subtotal and the money format always come from Liquid.

   Markup: snippets/roam-m-cart-drawer.liquid
   Styles: assets/roam-cart.css
   ========================================================================== */
(function () {
  'use strict';

  var DRAWER_ID = 'roam-m-cart';
  var OVERLAY_ID = 'roam-m-cart-overlay';
  var SECTION_ID = 'roam-cart-drawer';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function drawer() {
    return document.getElementById(DRAWER_ID);
  }

  function overlay() {
    return document.getElementById(OVERLAY_ID);
  }

  /* ---- open / close ------------------------------------------------------ */
  function open() {
    var el = drawer();
    if (!el) return false;
    el.setAttribute('data-open', 'true');
    el.setAttribute('aria-hidden', 'false');
    var ov = overlay();
    if (ov) ov.setAttribute('data-open', 'true');
    var close = el.querySelector('[data-rc-close]');
    if (close) close.focus();
    return true;
  }

  function close() {
    var el = drawer();
    if (el) {
      el.removeAttribute('data-open');
      el.setAttribute('aria-hidden', 'true');
    }
    var ov = overlay();
    if (ov) ov.removeAttribute('data-open');
  }

  /* ---- server-side re-render --------------------------------------------- */
  function render() {
    var el = drawer();
    if (!el) return Promise.resolve(false);
    return fetch(root() + '?section_id=' + SECTION_ID, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return false;
        var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(DRAWER_ID);
        if (!fresh) return false;
        el.innerHTML = fresh.innerHTML;
        return true;
      })
      .catch(function () { return false; });
  }

  function updateCount(cart) {
    document.querySelectorAll('[data-roam-cart-count]').forEach(function (node) {
      node.textContent = cart.item_count;
      node.classList.toggle('roam-cart-btn__count--empty', cart.item_count === 0);
    });
    document.querySelectorAll('.roam-cart-btn').forEach(function (btn) {
      btn.setAttribute('aria-label', 'Cart (' + cart.item_count + ' items)');
    });
  }

  /* ---- quantity changes --------------------------------------------------
     data-rc-line is the 1-based cart line; data-rc-change is the quantity to
     set it to (0 removes it). The free-pair row's REMOVE sets the line back
     to its paid count, which is why it carries a quantity rather than 0. */
  var busy = false;

  function change(line, quantity) {
    if (busy) return;
    var el = drawer();
    if (!el) return;
    busy = true;
    el.setAttribute('data-rc-busy', 'true');

    fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (cart) updateCount(cart);
        return render().then(function () {
          if (cart) {
            document.dispatchEvent(new CustomEvent('roam:cart:updated', { detail: cart, bubbles: true }));
          }
        });
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        var node = drawer();
        if (node) node.removeAttribute('data-rc-busy');
      });
  }

  /* ---- delegated events --------------------------------------------------
     Bound to document once, so the handlers survive the innerHTML swap that
     render() performs. */
  document.addEventListener('click', function (event) {
    var el = drawer();

    var closer = event.target.closest('[data-rc-close]');
    if (closer && el && el.contains(closer)) {
      event.preventDefault();
      close();
      return;
    }

    var control = event.target.closest('[data-rc-change]');
    if (!control || !el || !el.contains(control)) return;
    event.preventDefault();

    var line = parseInt(control.getAttribute('data-rc-line'), 10);
    var quantity = parseInt(control.getAttribute('data-rc-change'), 10);
    if (!line || isNaN(quantity)) return;
    change(line, quantity);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var el = drawer();
    if (el && el.hasAttribute('data-open')) close();
  });

  /* ---- public hooks used by the header and roam-pdp.js -------------------- */
  window.roamCart = { open: open, close: close, render: render };
})();
